import { Card, CircularProgress, Grid, Paper } from "@material-ui/core";
import { getRequest } from "api/apiCaller";
import API_URL from "constant/api-url";
import { isNil } from "lodash";
import { useSnackbar } from "notistack";
import mainClasses from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAuthenticatedSdk,
  setRingmeOttSdk,
  setThreadInfo,
  setUserChatInfo,
} from "redux/ringme-ott-sdk";

import AgentDashboardHeader from "./agent-chat-header/AgentDashboardHeader";
import ChatList from "./chat-list";
import Ticket from "./ticket";

const AgentChatTicket = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [isUserSyncSdk, setIsUserSyncSdk] = useState(false);
  const [loading, setLoading] = useState(true);

  const ringmeOttSdk = useSelector((state) => state.ringmeOttSdk.ringmeOttSdk);

  const userInfo = useSelector((state) => state.ringmeOttSdk.userChatInfo);
  const agentChatStatus = useSelector(
    (state) => state.ringmeOttSdk.agentChatStatus
  );
  const user = useSelector((state) => state.auth.init);

  useEffect(() => {
    getRequest(API_URL.CHAT_INFO)
      .then((res) => {
        if (res.data?.username && res.data?.password) {
          dispatch(setUserChatInfo(res.data));
          setIsUserSyncSdk(true);
          setLoading(false);
        } else {
          setIsUserSyncSdk(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err.message);
        setLoading(false);
      });

    const MAX_TIME_FOR_REQUESTS = 30 * 1000; // tổng thời gian check giới hạn trong 30s
    const CHECK_TIME = 1000; // 1s check 1 lần
    let totalTime = 0;
    const loadChatSDKInterval = setInterval(() => {
      const RingmeOttSdk = window.RingmeOttSdk;
      const converse = window.converse;

      if (RingmeOttSdk && converse) {
        dispatch(setRingmeOttSdk(RingmeOttSdk));
        clearInterval(loadChatSDKInterval);
      } else {
        if (totalTime > MAX_TIME_FOR_REQUESTS)
          clearInterval(loadChatSDKInterval);
        totalTime += CHECK_TIME;
      }
    }, CHECK_TIME);

    return () => {
      clearInterval(loadChatSDKInterval);
    };
  }, [dispatch]);

  useEffect(() => {
    if (userInfo && ringmeOttSdk && agentChatStatus === "service" && user) {
      console.log("init params ringme", {
        authentication: "login",
        username: userInfo.username,
        token: userInfo.password,
        appId: "OneCX",
        titleBox: "Hỗ trợ mọi lúc mọi nơi",
        is_supervisor: user.profile?.user?.role === "Supervisor",
      });
      ringmeOttSdk.init(
        {
          authentication: "login",
          username: userInfo.username,
          token: userInfo.password,
          appId: "OneCX",
          titleBox: "Hỗ trợ mọi lúc mọi nơi",
          is_supervisor: user.profile?.user?.role === "Supervisor",
        },
        function onConnected(event) {
          dispatch(setIsAuthenticatedSdk(true));
          console.log(event);
        },
        function onConnectFail(event) {
          dispatch(setIsAuthenticatedSdk(false));
          let message;
          if (!isNil(event.code)) {
            switch (event.code) {
              case "23":
                message =
                  "Vui lòng tải lại hoặc liên hệ đầu mối quản trị hệ thống của Tổng công ty để được hỗ trợ";
                break;
              case "20":
                message =
                  "Sai thông tin tài khoản chat, mật khẩu hoặc chưa được kích hoạt tính năng chat. Vui lòng liên hệ với đầu mối quản trị hệ thống của Tổng công ty để được hỗ trợ. Trân trọng.";
                break;
              case "21":
                message =
                  "Tài khoản Chat gắn với số điện thoại của Bạn đã đăng nhập vào ứng dụng One CX đồng thời trên thiết bị khác. Xin vui lòng kiểm tra lại các thiết bị đã đăng nhập One CX để thoát khỏi. Trân trọng.";
                break;
              case "22":
                message =
                  "Tính năng Chat trên One CX gắn với tài khoản của Bạn đang bị khóa. Xin vui lòng liên hệ với bộ phận quản trị hệ thống của Tổng công ty để được hỗ trợ. Trân trọng.";
                break;
              default:
                break;
            }
          }
          if (message) {
            enqueueSnackbar(message, {
              variant: "warning",
            });
          }
          console.log(event);
        },
        function handleNumberUnread(numUnread) {
          console.log(numUnread); // trả về số lượng tin nhắn chưa đọc
        },
        function handleMessage(message) {
          // trả về thông tin tin nhắn đến
          console.log("message", message);
          if (message)
            enqueueSnackbar(message.message, {
              variant: message.code === "03" ? "warning" : "info",
            });
        },
        function handleOpenChat(result) {
          // result ở dạng:
          // {
          // message: ‘Success’ , // ‘Success’, ‘user not exist’, ‘user not online’…
          // code: ‘01’, // mã trạng thái ứng với các trường hợp
          //}
          console.log(result); // trả về thông tin tin nhắn đến
        },
        function handleOpenChatQueue(result) {
          // result ở dạng:
          // {
          // message: ‘Success’ , // ‘Success’, queue not exist’, …
          // code: ‘01’, // mã trạng thái ứng với các trường hợp
          //}
          console.log(result); // trả về thông tin tin nhắn đến
        },
        function onChatThreadChanged(threadInfo) {
          console.log("ChatThreadChanged", threadInfo);
          // sự kiện khi mở 1 chat thread (ấn vào các cuộc hội thoại ở phần)
          // lịch sử chat, khi ấn Bắt đầu, Kết thúc.
          // . ThreadInfo gồm thông tin về Thread bao gồm threadId, action vừa thực hiện ví dụ như: Open, Start, End.
          // , Thông tin loại chat 1-1 hoặc Queue, QueueId
          // , thông tin của người nhắn tin gồm Username, họ tên, số điện thoại, email, vị trí, bộ phận (nếu là nhân viên)
          // , thông tin nguồn chat appId tương ứng vơi (mvnp, onecx, pns, dd)
          dispatch(setThreadInfo(threadInfo));
        },
        function onChatThreadCreated(result) {
          console.log("onChatThreadCreated", onChatThreadCreated);
        },
        function onStatusChanged(result) {
          console.log(result);
        }
      );
    }
  }, [
    userInfo,
    ringmeOttSdk,
    dispatch,
    enqueueSnackbar,
    agentChatStatus,
    user,
  ]);

  return (
    <>
      {loading && (
        <div className={mainClasses.fullScreenWrapper}>
          <CircularProgress />
        </div>
      )}

      {!loading && !isUserSyncSdk && (
        <div className={mainClasses.fullScreenWrapper}>
          <div className={mainClasses.labelSyncUser}>
            Tài khoản này chưa được đồng bộ chat, cần cập nhật thông tin tài
            khoản!
          </div>
        </div>
      )}

      {!loading && isUserSyncSdk && (
        <Grid container style={{ height: "100%" }}>
          <Grid
            item
            xl={8}
            lg={8}
            md={6}
            xs={12}
            style={{ display: "flex", flexDirection: "column" }}
            className={mainClasses.gridItemLeft}>
            <Card style={{ marginBottom: 6 }}>
              <AgentDashboardHeader />
            </Card>

            <ChatList />
          </Grid>
          <Grid
            item
            xl={4}
            lg={4}
            md={6}
            xs={12}
            className={mainClasses.gridItemRight}>
            <Paper style={{ padding: 10, overflow: "auto" }}>
              <Ticket />
            </Paper>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AgentChatTicket;
